import React from 'react';

export default function TailwindPurgeClasses() {
  return (
    <div>
      {/* Tailwind purge whitelist (yes this is very ugly and probably the wrong way to do it but here we are )*/}
      <div className="hidden">
        <div
          className={`
max-w-xxxs max-w-xxs max-w-xs max-w-sm max-w-md max-w-lg max-w-2xl max-w-3xl max-w-4xl text-h1 text-h2 text-h3 text-h4

my-0.5	mt-0.5	mb-0.5 	mx-0.5	ml-0.5	mr-0.5
my-1		mt-1		mb-1 		mx-1		ml-1		mr-1
my-1.5	mt-1.5	mb-1.5 	mx-1.5	ml-1.5	mr-1.5
my-2		mt-2		mb-2 		mx-2		ml-2		mr-2
my-2.5	mt-2.5	mb-2.5 	mx-2.5	ml-2.5	mr-2.5
my-3		mt-3		mb-3 		mx-3		ml-3		mr-3
my-3.5	mt-3.5	mb-3.5 	mx-3.5	ml-3.5	mr-3.5
my-4		mt-4		mb-4 		mx-4		ml-4		mr-4
my-5		mt-5		mb-5 		mx-5		ml-5		mr-5
my-6		mt-6		mb-6	 	mx-6		ml-6		mr-6
my-7		mt-7		mb-7	 	mx-7		ml-7		mr-7
my-8		mt-8		mb-8	 	mx-8		ml-8		mr-8
my-9		mt-9		mb-9 		mx-9		ml-9		mr-9
my-10		mt-10		mb-10 	mx-10		ml-10		mr-10
my-11		mt-11		mb-11 	mx-11		ml-11		mr-11
my-12		mt-12		mb-12 	mx-12		ml-12		mr-12
my-14		mt-14		mb-14 	mx-14		ml-14		mr-14
my-16		mt-16		mb-16 	mx-16		ml-16		mr-16
my-20		mt-20		mb-20 	mx-20		ml-20		mr-20
my-24		mt-24		mb-24 	mx-24		ml-24		mr-24
my-28		mt-28		mb-28 	mx-28		ml-28		mr-28
my-32		mt-32		mb-32 	mx-32		ml-32		mr-32
my-36		mt-36		mb-36 	mx-36		ml-36		mr-36
my-40		mt-40		mb-40 	mx-40		ml-40		mr-40
my-44		mt-44		mb-44 	mx-44		ml-44		mr-44
my-48		mt-48		mb-48 	mx-48		ml-48		mr-48
my-52		mt-52		mb-52 	mx-52		ml-52		mr-52
my-56		mt-56		mb-56 	mx-56		ml-56		mr-56
my-60		mt-60		mb-60 	mx-60		ml-60		mr-60
my-64		mt-64		mb-64 	mx-64		ml-64		mr-64
my-72		mt-72		mb-72 	mx-72		ml-72		mr-72
my-80		mt-80		mb-80 	mx-80		ml-80		mr-80
my-96		mt-96		mb-96 	mx-96		ml-96		mr-96
`}
        />
      </div>
    </div>
  );
}
